import React from 'react'
import Loader from './loader'

function CDButton({ disabled, processing, label, type, className, ...rest }) {
  return (
    <button
      type={type || 'submit'}
      disabled={disabled || processing}
      className={`btn ${disabled || processing ? 'disable' : ''} ${className}`}
      {...rest}
    >
      {processing ? <Loader /> : label}
    </button>
  )
}

export default CDButton
